import axios from "../axios";

const deleteWithdrawAccount = async (accessToken, id) => {
    try {
        const response = await axios.post(`withdraw-account/deleteWithdrawAccount`, {
            id: id
        }, {
            headers: {
                Authorization: accessToken
            }
        });
        return response.data;
    } catch (error) {
        return {
            success: false,
            message: error.response?.data?.message || 'Có lỗi xảy ra khi xóa tài khoản'
        };
    }
};

export default deleteWithdrawAccount;
